'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var SessionContext = require('../../providers/SessionContext.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var ItemSelectionProvider = require('./ItemSelectionProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionViewRoot = _ref => {
  let {
    children
  } = _ref;
  const {
    state: {
      claimType
    },
    getFullItemDetails
  } = index.useClaimBuilder();
  const logEvent = useAnalytics["default"]();
  const titan = useTitanAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    eligibleShipments,
    ineligibleShipments,
    itemClaims
  } = ItemSelectionProvider.useItemSelection();
  React.useEffect(() => {
    const itemsEligible = eligibleShipments.flatMap(shipment => shipment.items.map(item => {
      const fullItemDetails = getFullItemDetails(item.itemRefId, shipment.id);
      if (!fullItemDetails) throw new Error(`No item details found for item: ${item.itemRefId}`);
      return {
        isSelected: !!itemClaims[`${item.itemRefId}_${shipment.id}`],
        item_id: fullItemDetails.itemId,
        sku: fullItemDetails.sku,
        name: fullItemDetails.name
      };
    }));
    const selectedItems = itemsEligible.filter(item => item.isSelected);
    const itemsIneligible = ineligibleShipments.flatMap(shipment => shipment.items.map(item => {
      const fullItemDetails = getFullItemDetails(item.itemRefId, shipment.id);
      if (!fullItemDetails) throw new Error(`No item details found for item: ${item.itemRefId}`);
      return {
        item_id: fullItemDetails.itemId,
        sku: fullItemDetails.sku,
        name: fullItemDetails.name,
        ineligibility_reason: fullItemDetails.evaluatedEligibility.ineligibilityReason
      };
    }));
    const batchEvent = {
      batch: [{
        type: 'page',
        name: 'Item Selection'
      }, {
        event: 'products_list_viewed',
        type: 'track',
        properties: {
          list_id: 'item_selection',
          products: [...itemsEligible, ...itemsIneligible].map(item => ({
            product_id: item.item_id,
            sku: item.sku,
            name: item.name,
            category: item.ineligibility_reason
          }))
        }
      }]
    };
    if (selectedItems.length) {
      batchEvent.batch.push({
        event: 'cart_viewed',
        type: 'track',
        properties: {
          products: selectedItems.map(item => ({
            product_id: item.item_id,
            sku: item.sku,
            name: item.name
          }))
        }
      });
    }
    titan === null || titan === void 0 ? void 0 : titan.batch(batchEvent)
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_SELECTION,
      page_step: useAnalytics.ClaimsPageStep.SELECTION,
      order_number: orderNumber,
      claim_reason: claimType,
      items_eligible: itemsEligible !== null && itemsEligible !== void 0 && itemsEligible.length ? itemsEligible : undefined,
      items_ineligible: itemsIneligible !== null && itemsIneligible !== void 0 && itemsIneligible.length ? itemsIneligible : undefined
    });
  }, [logEvent, claimType, orderNumber, eligibleShipments, ineligibleShipments, getFullItemDetails, itemClaims, titan]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const ItemSelectionViewRootGuarded = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    state: {
      claimEligibilityInfo,
      itemClaims
    },
    handleInvalidData
  } = index.useClaimBuilder();
  const {
    shipments,
    items
  } = claimEligibilityInfo ?? {};
  if (!shipments || !items) {
    handleInvalidData();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(ItemSelectionProvider.ItemSelectionProvider, {
    value: {
      shipments,
      itemClaims
    }
  }, /*#__PURE__*/React__default["default"].createElement(ItemSelectionViewRoot, null, children));
};

exports["default"] = ItemSelectionViewRootGuarded;
